/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const TableAndChartIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Table And Chart',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M33 20H3a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V21a1 1 0 0 0-1-1ZM12 32H4v-4h8Zm0-6H4v-4h8Zm20 6H14v-4h18Zm0-6H14v-4h18Z"
    />
    <rect height="16" rx="1" ry="1" width="8" x="26" y="2" />
    <rect height="10" rx="1" ry="1" width="8" x="14" y="8" />
    <rect height="6" rx="1" ry="1" width="8" x="2" y="12" />
  </svg>`;
};
